/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IKrannichYoutubePlaylistViewProps } from './krannich-youtube-playlist';

export default (props: IKrannichYoutubePlaylistViewProps) => {
    const [isLoaded, setIsLoaded] = React.useState(false);
    const { youtubeLink, uniqueId } = props.config;
    const handleLoad = () => {
        setIsLoaded(true);
    };
    return (
        <>
            <div id={uniqueId} className='youtube-playlist'>
                <iframe
                    width='560'
                    height='315'
                    src={youtubeLink ?? ''}
                    title='YouTube video player'
                    frameBorder='0'
                    allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                    allowFullScreen
                    onLoad={handleLoad}
                    style={{ display: isLoaded ? 'block' : 'none' }}
                ></iframe>
            </div>
        </>
    );
};
